var directive = function() {
  return {
    template: ' {{transcludeText}}\
                <span ng-transclude> </span>\
                <div ng-style="style()" ng-if="enabled && display" class="tooltip {{tooltipClass}}">\
                  {{content}}\
                </div>',
    transclude: true,
    link: function (scope,element,attrs) {
      scope.display = false;

      if(attrs.tooltipEnabled) {
        scope.enabled = scope.tooltipEnabled
      } else {
        scope.enabled = true
      }

      scope.style = function() {
        style = {top: (element.offsetTop + element.clientHeight) + "px"};
        if (scope.tooltipWidth) {
          style.width = scope.tooltipWidth;
        }

        if ((scope.tooltipPosition == 'left') && scope.tooltipWidth ) {
          style.top = element.offsetTop + "px";
          style.left = element.offsetLeft - 10 - parseInt(scope.tooltipWidth) + "px";
        }

        if (scope.tooltipPosition == 'right') {
          style.top = element.offsetTop + "px";
          style.left = element.offsetLeft + element.clientWidth + 5 + "px";
        }

        return style;
      };

      var showTooltip = function() {
        scope.display = true;
        scope.$apply();
      };
      var hideTooltip = function() {
        scope.display = false;
        scope.$apply();
      };

      element.on('mouseenter', showTooltip);
      element.on('mouseleave', hideTooltip);
    },
    scope: {
      content: '@tooltip',
      transcludeText: '@',
      tooltipWidth: '@',
      tooltipClass: '@',
      tooltipEnabled: '=',
      tooltipPosition: '@'
    }
  };
};

tiz.directive('tooltip', directive);
